import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Reel } from "../GameComponents/Reel";
import { Symbol } from "../GameComponents/Symbol";

/**
 * ReelExtended handles:
 * - z-order
 * - usage of Normal instead of Rotation
 */
@engineComponent(ComponentTypes.DisplayObject)
export class ReelExtended extends Reel {
    public static Tease: boolean = false;

    //******************************************************************************************************************
    //  SHOW SYMBOLS, SPIN ROLL
    //******************************************************************************************************************

    public showSymbols(useTransform: boolean = false): void {
        this.shouldBeStopping = false;
        this.isStopping = false;
        this.stoppingCounter = 0;
        this.isTeasing = false;
        this.teasingSymbols = [];

        this.x = this.positionX;
        this.y = this.positionY;

        if (!useTransform) {
            while (this.currentSymbols.length > 0) {
                this.returnSymbol(this.currentSymbols.pop());
            }
        }

        let bottomSymbols: Array<Symbol> = [];
        let topSymbols: Array<Symbol> = [];

        for (let i = 0; i < this.symbolBottomCount + this.symbolCount + this.symbolTopCount; i++) {
            let symbolId: number;
            let symbolCase: string;

            if (i < this.symbolBottomCount) {
                symbolId =
                    this.strip[
                        (this.data.index + this.symbolBottomCount + this.symbolCount - i - 1 + this.strip.length) %
                            this.strip.length
                    ];
                symbolCase = i === this.symbolBottomCount - 1 ? Symbol.CaseRotation : Symbol.CaseBlur;
            } else if (i < this.symbolBottomCount + this.symbolCount) {
                symbolId = this.data.symbols[this.symbolBottomCount + this.symbolCount - i - 1];
                symbolCase = Symbol.CaseRotation;
            } else {
                symbolId =
                    this.strip[
                        (this.data.index + this.symbolBottomCount + this.symbolCount - i - 1 + this.strip.length) %
                            this.strip.length
                    ];
                symbolCase = i === this.symbolBottomCount + this.symbolCount ? Symbol.CaseRotation : Symbol.CaseBlur;
            }

            if (!useTransform) {
                // when we don't want use symbols from WinAnimator
                this.currentSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));
            } else {
                // currentSymbols are used from WinAnimator. We only need to add new top and bottom symbols
                if (i < this.symbolBottomCount) {
                    bottomSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));
                } else if (i > this.symbolBottomCount + this.symbolCount - 1) {
                    topSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));
                } else if (this.currentSymbols[this.symbolCount - i] == null) {
                    //add symbol below expanded wild
                    this.currentSymbols[this.symbolCount - i] = this.getSymbol(symbolId - 1, symbolCase);
                }
            }
        }

        if (useTransform) {
            while (bottomSymbols.length > 0) {
                this.currentSymbols.push(bottomSymbols.shift());
            }

            while (topSymbols.length > 0) {
                this.currentSymbols.unshift(topSymbols.shift());
            }
        }

        for (let i = 0; i < this.currentSymbols.length; i++) {
            this.addChild(this.currentSymbols[i]);

            const symbol = this.currentSymbols[i];
            symbol.x = -symbol.offsetX;
            symbol.y = this.symbolHeight * (i - this.symbolTopCount) - symbol.offsetY;
        }

        if (this.data.transform) {
            for (let i = this.symbolTopCount; i < this.symbolCount + this.symbolTopCount; i++) {
                this.currentSymbols[i].goToCase(Symbol.CaseEmpty);
            }
        }

        this.moveToTop();
    }

    protected updateReel(): void {
        super.updateReel();

        this.moveToTop();
    }

    private moveToTop(): void {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            const symbol = this.currentSymbols[i];

            if (symbol !== null && symbol.id === 6) {
                symbol.parent.addChild(symbol);
            }
        }

        for (let i = 0; i < this.currentSymbols.length; i++) {
            const symbol = this.currentSymbols[i];

            if (symbol !== null && symbol.id === 7) {
                symbol.parent.addChild(symbol);
            }
        }
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    protected getSymbol(symbolId: number, symbolCase: string): Symbol {
        if (symbolCase === Symbol.CaseRotation) {
            symbolCase = Symbol.CaseNormal;
        }

        const symbol = super.getSymbol(symbolId, symbolCase);

        if (ReelExtended.Tease) {
            if (symbol.id !== 7) {
                symbol.goToCase(Symbol.CaseNowin);
            }
        }

        return symbol;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ReelExtended.ts
 **/